(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.freckleBuyCardInit) return;
    window.freckleBuyCardInit = true;

    // Delegated, so it also works inside quick view and after section re-renders.
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form.closest || !form.closest('.buy-card')) return;
      event.preventDefault();

      const button = form.querySelector('.buy-card__button');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }

      const data = new FormData(form);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: data.get('id'), quantity: Number(data.get('quantity')) || 1 }),
        });
        if (!response.ok) throw new Error('add to cart failed');
        window.location.assign(root + 'checkout');
      } catch (error) {
        // Fallback: a normal post adds the item and lands on the cart page.
        form.submit();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
